
import StarIcon from "@material-ui/icons/Star";
import EcoIcon from '@material-ui/icons/Eco';
import classes from "./Competition.module.css";
import Utils from "../../Utils";


const LEVELS = [
  {
    title: "Primary",
    badge: "Class 3–5",
    className: "primary",
    fiction: [
      "The Magic Lunchbox",
      "The Tree That Could Talk",
      "My Pet From Another Planet",
      "The Magical School Bus",
      "Adventures in My Dreams",
    ],
    nonFiction: [
      "A Day Without Gadgets",
      "My Favorite Animal",
      "If I Could Invent Something",
      "My Family Traditions",
      "How I Help Save The Planet",
    ],
  },
  {
    title: "Middle",
    badge: "Class 6–8",
    className: "middle",
    fiction: [
      "My Life on Mars",
      "The Mystery of the Disappearing Students",
      "The Last Library on Earth",
      "Time Travel Homework Excuse",
      "The Secret Diary of a Superhero",
    ],
    nonFiction: [
      "How Social Media Affects My Life",
      "Adventures in Coding",
      "The Sports That Changed Me",
      "My Favorite Scientific Discovery",
      "The Future I Want to Build",
    ],
  },
  {
    title: "Senior",
    badge: "Class 9–12",
    className: "senior",
    fiction: [
      "What If Humans Could Read Minds?",
      "The Last Generation",
      "Digital Immortality",
      "The Memory Collector",
      "When AI Becomes Human",
    ],
    nonFiction: [
      "Why Therapy Should Be Normal in Schools",
      "Climate Change: Our Generation's Challenge",
      "The Future of Education",
      "Technology: Blessing or Curse?",
      "Finding Your Voice in a Noisy World",
    ],
  },
];

/**
 * Renders a topic list section (Fiction or Non-Fiction)
 */
const TopicList = ({ title, topics, Icon }) => (
  <div className={classes.topicsWrapper}>
    <p>{title}:</p>
    <ul>
      {topics.map((topic, idx) => (
        <li key={idx}>
          <Icon /> {topic}
        </li>
      ))}
    </ul>
  </div>
);

/**
 * Renders an entire level card with its topics
 */
const LevelCard = ({ level }) => (
  <div className={Utils.getClasses(classes.step, classes[level.className])}>
    <h3>{level.title}</h3>
    <div className={classes.topics}>
      <div className={classes.heroBadge}>{level.badge}</div>
    </div>

    <TopicList title="Fiction" topics={level.fiction} Icon={StarIcon} />
    <TopicList title="Non-Fiction" topics={level.nonFiction} Icon={EcoIcon} />
  </div>
);

export default function LevelSection() {
  return (
    <section className={classes.levelSection}>
      <div className={classes.container}>
        <h2 className={classes.stepsTitle}>Choose Your Level &amp; Topic</h2>
        <div className={classes.steps}>
          {LEVELS.map((level, idx) => (
            <LevelCard key={idx} level={level} />
          ))}
        </div>
      </div>
    </section>
  );
}
